import { render, staticRenderFns } from "./UploadFormData.vue?vue&type=template&id=4da034f2&scoped=true&"
import script from "./UploadFormData.vue?vue&type=script&lang=js&"
export * from "./UploadFormData.vue?vue&type=script&lang=js&"
import style0 from "./UploadFormData.vue?vue&type=style&index=0&id=4da034f2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da034f2",
  null
  
)

export default component.exports